import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { logout } from "../components/App";
import { Modal } from 'antd';

const DEFAULT_TIMEOUT = 30 * 60 * 1000; // 30 minuti

const SessionManager = () => {
    //const sessionTimeout = 60 * 60 * 1000; // 1 ora
    const timerRef = useRef(null);
    const location = useLocation();
    const [sessionExpired, setSessionExpired] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);

    const getSessionTimeout = () => {
        const storedTimeout = sessionStorage.getItem('sessionTimeout');
        const parsed = parseInt(storedTimeout, 10);
        return isNaN(parsed) ? DEFAULT_TIMEOUT : parsed;
    };

    const handleLogout = () => {
        setSessionExpired(false);
        setModalVisible(false);
        logout();
    };

    const resetTimer = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }

        const sessionTimeout = getSessionTimeout();
        timerRef.current = setTimeout(() => {
            setSessionExpired(true);
        }, sessionTimeout);
    };

    useEffect(() => {
        if (location.pathname === '/demetra/login') {
            return;
        }

        const events = ['mousemove', 'keydown', 'click'];
        events.forEach(event => window.addEventListener(event, resetTimer));

        resetTimer(); // Inizializza il timer

        return () => {
            events.forEach(event => window.removeEventListener(event, resetTimer));
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
        };
    }, [location.pathname]);

    // Quando la sessione scade, mostra la modale
    useEffect(() => {
        if (sessionExpired) {
            Modal.info({
                title: 'Sessione scaduta',
                content: 'Clicca "Ok" per effettuare nuovamente l’accesso.',
                okText: 'Ok',
                centered: true,
                onOk: handleLogout,
            });
        }
    }, [sessionExpired]);

    return null;
};

export default SessionManager;